import React from 'react'
import Navbar from '../inc/Navbar'
import VideoGallery from './VideoGallery'

function Videopage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
          <VideoGallery/>
          <br/>
    </div>
  )
}

export default Videopage